export default "__VITE_ASSET__c_lk5Bkp__"